import { createSlice } from "@reduxjs/toolkit";
import { set } from "lodash";
import { v4 as uuidv4 } from "uuid"; // For generating unique IDs for components

export const initialState = {
  dashboard_list:[],
  dashboard_loader:false,
  fav_prompt_list:[],
  selected_fav_prompt_id_element:null,
  selected_fav_prompt_data:null,
  selected_xaxis_value:null,
  selected_yaxis_value:null,
  selected_labelling_value:null,
  selected_theta_value:null,
  dnd_components:[],
  dashboard_category:[],
  dashboard_category_by_group:[],
  drag_drop_canvas_loader:false,
  dashboard_list_loader:true,
  group_bot_list:[],
  side_panel_loader:false, 
  new_element:[],
  rename_modal_status:false, 
  edit_chart_modal_status:false,
  title_element:null,
  title_id:null,
  temp_title:" ",
  edit_element_id:null
  // options_value_loader:false
  
  
 
};

const Dashboard_Slice = createSlice({
  name: "Dashboard",
  initialState,
  reducers: {
    set_dashboard_list(state, action) {
      state.dashboard_list=action.payload
    },
    set_side_panel_loader(state,action){
      state.side_panel_loader=action.payload
    },
    set_dashboard_loader(state,action){
     state.dashboard_loader=action.payload
    },

    set_fav_prompt_list(state,action){
        state.fav_prompt_list=action.payload
    },

    set_selected_fav_prompt_id_element(state, action){
        state.selected_fav_prompt_id_element = action.payload
    },
    set_selected_fav_prompt_data(state,action){
        state.selected_fav_prompt_data = action.payload
    },

    set_selected_xaxis(state,action){
        state.selected_xaxis_value= action.payload
    },

     set_selected_yaxis(state,action){
      state.selected_yaxis_value= action.payload
    },

    set_selected_labelling(state,action){
        state.selected_labelling_value= action.payload
    },

    set_selected_theta(state,action){
        state.selected_theta_value= action.payload
    },

    set_dnd_components(state,action){
        console.log("Dnd Components is called",
          action.payload
        )
        state.dnd_components = action.payload
    },

    set_dashboard_category_by_group(state,action){
      state.dashboard_category_by_group = action.payload
    },

    set_dashboard_category(state,action){
      state.dashboard_category=action.payload
    },
    set_group_bot_list(state,action){
      state.group_bot_list=action.payload
    },
    set_temp_title(state,action){
      state.temp_title = action.payload
    },
    add_component_to_canvas(state,action) {
      const { type , data , title , favorite_prompt_id , X_Axis_Column , Y_Axis_Column , Labelling_Column, Theta_Column } = action.payload
      // console.log(action.payload);
      
      // const rect = document.querySelector("#canvas-zone").getBoundingClientRect();
    
      const componentWidth = 200;
      const componentHeight = 150;
    
      // Random x and y within canvas bounds
const x = 20;
const y = 0;
    
      const newComponent = {
        id: uuidv4(),
        type,
        x,
        y,
        width: null,
        height: null,
        data,
        title,
        favorite_prompt_id
      };
    
      state.dnd_components=[...state.dnd_components , newComponent]
    },


    set_component_to_canvas(state,action) {
      
    
      state.dnd_components=action.payload
    },

    set_dashboard_list_loader(state,action){
      state.dashboard_list_loader = action.payload
    },

    set_drag_drop_canvas_loader(state,action){
    state.drag_drop_canvas_loader = action.payload
    },
    setnew_element(state,action){
      state.new_element = action.payload
    },
    set_rename_modal(state,action){
      state.rename_modal_status=action.payload
    },
     set_edit_chart_modal_status(state,action){
      state.edit_chart_modal_status=action.payload
    },

    set_title_id(state,action){
      state.title_id=action.payload
      
    },

    
    set_edit_element_id(state,action){
      state.edit_element_id=action.payload
      
    },

      set_title_element(state,action){
      state.title_element=action.payload
      
    },

    // set_options_value_loader(state,action){
    //   state.options_value_loader = action.payload
    // },
     reset_dashboard_reducer:() => initialState

     
     

  },
});

export const {
    set_dnd_components,
    set_selected_xaxis,
    set_selected_yaxis,
    set_selected_labelling,
    set_selected_theta,
    set_dashboard_list,
    set_fav_prompt_list,
    set_dashboard_loader,
    reset_dashboard_reducer,
    set_selected_fav_prompt_id_element,
    set_selected_fav_prompt_data,
    add_component_to_canvas,
    set_component_to_canvas,
    set_dashboard_category,
    set_dashboard_category_by_group,
    set_dashboard_list_loader,
    set_group_bot_list,
    set_drag_drop_canvas_loader,
    set_side_panel_loader,
    set_temp_title,
    setnew_element,
    set_title_id,
    set_title_element,
    set_rename_modal,
    set_edit_chart_modal_status,
    set_edit_element_id

} = Dashboard_Slice.actions

export default Dashboard_Slice.reducer;